import { Grid, Select } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class StockTransferTaskPageStyle extends CommonComponentStyle {
  SubtitleWrapper = styled(Grid)`
    padding: 8px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  `;

  Subtitle = styled(Grid)`
    font-weight: 700;
    font-size: 14px;
  `;

  ItemContentWrapper = styled(Grid)`
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
    &.table-content {
      padding: 8px 16px;
      font-size: 14px;
    }
  `;

  SubHeaderText = styled.p`
    font-weight: 700;
    font-size: 14px;
    color: ${this.colors.PRIMARY_GRAY};
  `;

  InputWrapper = styled(Grid)`
    margin-top: 8px !important;
  `;

  SelectBinType = styled(Select)`
    margin: 8px 0;
    width: 150px;
    font-size: 14px;
  `;

  PaginationRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-left: auto;
  `;

  PaginationText = styled.span`
    font-size: 12px;
    color: ${this.colors.PRIMARY_GRAY};
  `;

  PaginationControls = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
  `;

  PageNumber = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    font-size: 12px;
    color: ${this.colors.PRIMARY_GRAY};
  `;

  PaginationButton = styled(this.SecondaryButton)`
    width: auto !important;
    min-width: 32px !important;
    padding: 4px !important;
  `;
}

export const StockTransferTaskStyle = new StockTransferTaskPageStyle();
